// extracted by mini-css-extract-plugin
export default {"Wrapper":"Cancel_Wrapper__3PXgt"};